import styled, { css } from "styled-components";
import { Color, FontSize, Screen } from 'styles';

export const StyledContent = styled.div`
  padding-bottom: 100px;
 `;

const MediumContactColumnStyle = css`
  font-size: ${FontSize.S};
  margin-right: 0;
  width: 100%;
  
  &:last-child {
    margin-right: 0;
  }
`;

export const StyledContactColumn = styled.div`
  background-color: ${Color.White};
  border-left: 4px solid ${Color.Orange};
  display: inline-block;
  font-size: ${FontSize.M};
  margin: 30px 25px 0 0;
  padding: 60px 0;
  text-align: center;
  width: calc(50% - 25px);
  
  svg {
    fill: ${Color.Orange};
    margin-right: 20px;
    width: 50px;
    height: 50px;
    vertical-align: middle;
  }
  
  a {
    &:hover {
      text-decoration: underline;
    }
  }
  
  &:last-child {
    margin-right: 25px;
  }
  
  ${Screen.medium(MediumContactColumnStyle)}
`;

export const StyledLocaleWrapper = styled.section`
  background-color: ${Color.White};
  padding-top: 30px;
  width: 100%;
`;

export const StyledMap = styled.div`
  height: 500px;
  margin-top: 30px;
  position: relative;
  width: 100%;
  z-index: 1;
  
  > div {
    width: 100%!important;
  }
  svg {
    fill: ${Color.Orange};
    height: 50px;
    width: 50px;
  }
`;


// WEBPACK FOOTER //
// ./src/routes/contact/contact.style.js